

























































































































































import { Vue, Component } from 'vue-property-decorator';
import moment from 'moment';
import Toast from '@common/helpers/toast';
import PageLoader from '@components/common/PageLoader.vue';
import ContentLayout from '@components/layouts/Content.vue';
import PopupDelete from '@/components/common/PopupDelete.vue';
import Pagination from '@/components/common/Pagination.vue';
import { MessageTemplateModule } from '@/store';
import messageTemplateIcon from '@/assets/img/message-template-icon.svg';

@Component({
  components: {
    PageLoader,
    ContentLayout,
    PopupDelete,
    Pagination,
  },
})
export default class MessageTemplateSettings extends Vue {
  private iconHeader = messageTemplateIcon;
  private patientNamePlaceholder = '{{patient_name}}';
  private isSubmitting = false;
  private isCreate = true;
  private editingId: number | null = null;
  private deletingItem: any = null;

  private form: { title: string; content: string; display_order: number | string | null; is_active: boolean } = {
    title: '',
    content: '',
    display_order: null,
    is_active: true,
  };

  get list() {
    return MessageTemplateModule.list;
  }

  get isLoading() {
    return MessageTemplateModule.isLoading;
  }

  get paginate() {
    return MessageTemplateModule.paginate;
  }

  get totalCount() {
    return this.paginate.total;
  }

  get nextDisplayOrder() {
    return this.totalCount + 1;
  }

  get displayOrderOptions() {
    const max = this.isCreate ? this.nextDisplayOrder : this.totalCount || 1;
    return Array.from({ length: max }, (_, index) => index + 1);
  }

  get deleteConfirmMessage() {
    return this.deletingItem ? `「${this.deletingItem.title}」を削除します。よろしいですか？` : '';
  }

  private created() {
    this.fetchList(1);
  }

  private fetchList(page?: number) {
    MessageTemplateModule.fetchList({ page: page || this.paginate.current_page });
  }

  private onPageChange(page: number) {
    if (this.isLoading) {
      return;
    }
    this.fetchList(page);
  }

  private formatDateTime(value: string) {
    return value ? moment(value).format('YYYY/MM/DD HH:mm') : '';
  }

  private openCreate() {
    this.isCreate = true;
    this.editingId = null;
    this.form = { title: '', content: '', display_order: this.nextDisplayOrder, is_active: true };
    this.$modal.show('messageTemplateModal');
  }

  private openEdit(item: any) {
    this.isCreate = false;
    this.editingId = item.id;
    this.form = {
      title: item.title,
      content: item.content,
      display_order: item.display_order,
      is_active: item.is_active,
    };
    this.$modal.show('messageTemplateModal');
  }

  private closeModal() {
    this.$modal.hide('messageTemplateModal');
  }

  private async submit() {
    if (this.isSubmitting) {
      return;
    }
    try {
      this.isSubmitting = true;
      const payload: any = {
        title: this.form.title,
        content: this.form.content,
      };
      const order = this.form.display_order;
      if (order !== null && String(order).trim() !== '') {
        payload.display_order = Number(order);
      }
      if (!this.isCreate) {
        payload.is_active = this.form.is_active;
      }

      if (this.isCreate) {
        await MessageTemplateModule.createTemplate(payload);
      } else {
        await MessageTemplateModule.updateTemplate({ id: this.editingId as number, data: payload });
      }
      Toast.success('保存しました');
      this.closeModal();
    } catch (error) {
      Toast.error((error as any)?.response?.data?.message || 'エラーが発生しました');
    } finally {
      this.isSubmitting = false;
    }
  }

  private confirmDelete(item: any) {
    this.deletingItem = item;
    this.$modal.show('messageTemplateDeleteModal');
  }

  private closeDeleteModal() {
    this.$modal.hide('messageTemplateDeleteModal');
    this.deletingItem = null;
  }

  private async deleteTemplate() {
    if (!this.deletingItem) {
      return;
    }
    try {
      await MessageTemplateModule.deleteTemplate(this.deletingItem.id);
      Toast.success('削除しました');
    } catch (error) {
      Toast.error((error as any)?.response?.data?.message || 'エラーが発生しました');
    } finally {
      this.$modal.hide('messageTemplateDeleteModal');
      this.deletingItem = null;
    }
  }
}
